import React from 'react';
import { useLocation } from 'react-router-dom';
import CardsFromMenuPage from './CardsFromMenuPage';

/**
 * Página genérica para qualquer módulo ou grupo do menu ThorJava.
 * 
 * Pega o pathname atual (ex: /modulo/tabelas, /g/basicas)
 * e delega para CardsFromMenuPage que busca os filhos no menu hierárquico.
 * 
 * Rotas que chegam aqui:
 *   /modulo/:slug  → módulos raiz (Tabelas, Vendas, ...)
 *   /g/:slug       → sub-grupos (Básicas, Funcionais, Reservadas, ...)
 */
const ModuloPage: React.FC = () => {
  const { pathname } = useLocation();
  return <CardsFromMenuPage rota={pathname} />;
};

export default ModuloPage;
